import React from 'react';

const ShipmentItemsList = ({ orderItems }) => {
  if (!orderItems || orderItems.length === 0) {
    return <p className="text-sm text-gray-500">No items found in this shipment.</p>;
  }

  return (
    <div className="pb-6">
      <h3 className="text-lg font-medium text-gray-600 mb-3">Items in this Shipment</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {orderItems.map(item => (
          <div key={item.id || item.product?.id} className="flex items-center p-3 border border-gray-100 rounded">
            <img 
               src={item.product?.photos?.[0]?.formats?.thumbnail?.url || item.product?.photos?.[0]?.url || 'https://via.placeholder.com/64'}
               alt={item.product?.name || 'Product image'}
               className="w-16 h-16 object-cover rounded mr-4 flex-shrink-0"
            />
            <div className="flex-grow">
              <p className="text-sm font-medium text-gray-800">{item.product?.name || 'Unknown Product'}</p>
              <p className="text-xs text-gray-500">
                Qty: {item.quantity}
                {/* Attempt to parse variantInfo if it's a JSON string, otherwise display as is if string */}
                {(() => {
                  let variantDisplay = null;
                  if (item.variantInfo) {
                    try {
                       // Check if it looks like a JSON object string
                       if (typeof item.variantInfo === 'string' && item.variantInfo.startsWith('{') && item.variantInfo.endsWith('}')) {
                          const parsed = JSON.parse(item.variantInfo);
                          // Example: display size and color if they exist
                          const parts = [];
                          if (parsed.size) parts.push(`Size: ${parsed.size}`);
                          if (parsed.color) parts.push(`Color: ${parsed.color}`);
                          if (parts.length > 0) {
                            variantDisplay = parts.join(', ');
                          } else {
                            // Fallback if JSON doesn't contain expected keys
                            variantDisplay = JSON.stringify(parsed);
                          }
                       } else if (typeof item.variantInfo === 'string') {
                          // If it's just a string, display it directly
                          variantDisplay = item.variantInfo;
                       }
                    } catch (e) {
                       console.error("Failed to parse variantInfo JSON:", item.variantInfo, e);
                       // Fallback for invalid JSON string
                       variantDisplay = typeof item.variantInfo === 'string' ? item.variantInfo : null;
                    }
                  } else if (item.variant?.name) {
                     // Fallback for older structure if present
                     variantDisplay = item.variant.name;
                  }
                  
                  return variantDisplay ? <span className="ml-2">({variantDisplay})</span> : null;
                })()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShipmentItemsList; 